import { BlackCheckIcon } from 'assets/images/countryList';

import './blackCheck.scss';

interface IBlackCheck {
  checked?: boolean;
  handleChangeCheck?: () => void;
}

const BlackCheck = ({ checked, handleChangeCheck }: IBlackCheck) => {
  return (
    <button type="button" id="blackCheck" onClick={() => handleChangeCheck?.()}>
      {checked ? <BlackCheckIcon /> : <div className="noBlackCheck" />}
    </button>
  );
};

export default BlackCheck;
